export default __webpack_public_path__ + "static/media/radiotelescopes_sunset_landscape.c1bbab0a.jpg";